import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReceivingReportHistoriesReportIdResponse } from '~/types/receive.types';

type TypeGetReportHistoriesByReportIdParams = {
  ownerCode: string;
  reportId: string;
};

const fetchReportHistoriesByReportId = async ({
  ownerCode,
  reportId,
}: TypeGetReportHistoriesByReportIdParams): Promise<TypeGetReceivingReportHistoriesReportIdResponse> => {
  const { data } = await axiosInstance.get<TypeGetReceivingReportHistoriesReportIdResponse>(
    `${API_ENDPOINT.RECEIVE.GET_REPORT_HISTORIES_REPORT_DETAIL}/${ownerCode}/report/histories/${reportId}`
  );
  return data;
};

/**
 * [입고관리 > 입고 리포트 관리] 입고 리포트 상세 조회 Mutation Hook
 */
export const useGetReportHistoriesByReportIdMutation = () => {
  return useMutation({
    mutationFn: fetchReportHistoriesByReportId,
  });
};
